const { loadScript } = require('../scriptLoader');
const BUNDLE_PATH = require('./bundlePath');

let pending = null;

function bundleUrl() {
  const issuer = window.MillaAuth?.getConfig?.()?.issuer;
  return issuer ? `${String(issuer).replace(/\/$/, '')}${BUNDLE_PATH}` : null;
}

// The player itself (StoriesPlayerCore with IMA, styles, show panel and
// analytics) is a lazy content-addressed bundle, loaded from the SDK issuer
// when an article container nears the viewport or a Shows player opens.
function loadStoriesPlayer() {
  if (typeof window === 'undefined') return Promise.reject(new Error('stories_unavailable'));
  if (window.MillaStories?.StoriesPlayerCore) return Promise.resolve(window.MillaStories);
  if (!pending) {
    const url = bundleUrl();
    if (!url) return Promise.reject(new Error('stories_issuer_missing'));
    pending = loadScript(url).then(() => {
      if (!window.MillaStories?.StoriesPlayerCore) throw new Error('stories_bundle_invalid');
      return window.MillaStories;
    });
    // A failed load can be retried by the next player.
    pending.catch(() => { pending = null; });
  }
  return pending;
}

// No page-start preload: the 2026-10-05 preload's bucket-0 holdout showed no
// effect on prerolls (plans/auth-embed-post-deploy-optimizations.md, week
// readout 2026-10-13), so it was removed to save the download.
module.exports = { loadStoriesPlayer };
